const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": true,
        "Type": "bios",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "66",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "150px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "image-default",
                                        "Type": "image",
                                        "Config": {
                                            "Block": {
                                                "width": "130px",
                                                "height": "130px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "name-default",
                                        "Type": "name",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontWeight": "",
                                                "fontStyle": "normal",
                                                "textTransform": "none",
                                                "fontSize": "14px",
                                                "lineHeight": "30px",
                                                "textLabelBirthdate": "b. ",
                                                "textLabelSeparator": " - ",
                                                "textLabelDeathdate": "d. ",
                                                "wrapDate": true,
                                                "colorDate": "",
                                                "styleDate": "header",
                                                "fontStyleDate": "normal",
                                                "fontWeightDate": ""
                                            },
                                            "Includes": {
                                                "Birthdate": true,
                                                "Deathdate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "bio-default",
                                        "Type": "bio",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "inventoryContainer-default",
                            "Type": "inventoryContainer",
                            "Config": {
                                "Block": {
                                    "columnCount": "3",
                                    "col1_width": "33.33%",
                                    "col1_verticalAlign": "top",
                                    "col1_paddingBottom": "20px",
                                    "col1_paddingRight": "20px",
                                    "col2_width": "33.33%",
                                    "col2_verticalAlign": "top",
                                    "col2_paddingBottom": "20px",
                                    "col2_paddingRight": "20px",
                                    "col2_collapseIfEmpty": true,
                                    "col3_width": "33.33%",
                                    "col3_verticalAlign": "top",
                                    "col3_paddingBottom": "20px",
                                    "col3_paddingRight": "20px",
                                    "col3_collapseIfEmpty": true
                                },
                                "Visibility": {
                                    "Inventory": true
                                },
                                "Style": {
                                    "paddingTop": "40px",
                                    "paddingBottom": "40px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "width": "160px"
                                            },
                                            "Style": {
                                                "paddingBottom": "20px",
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "bios",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "66",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "150px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "image-default",
                                        "Type": "image",
                                        "Config": {
                                            "Block": {
                                                "width": "130px",
                                                "height": "130px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "name-default",
                                        "Type": "name",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontWeight": "",
                                                "fontStyle": "normal",
                                                "textTransform": "none",
                                                "fontSize": "14px",
                                                "lineHeight": "30px",
                                                "textLabelBirthdate": "b. ",
                                                "textLabelSeparator": " - ",
                                                "textLabelDeathdate": "d. ",
                                                "wrapDate": true,
                                                "colorDate": "",
                                                "styleDate": "header",
                                                "fontStyleDate": "normal",
                                                "fontWeightDate": ""
                                            },
                                            "Includes": {
                                                "Birthdate": true,
                                                "Deathdate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "bio-default",
                                        "Type": "bio",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "inventoryContainer-default",
                            "Type": "inventoryContainer",
                            "Config": {
                                "Block": {
                                    "columnCount": "3",
                                    "col1_width": "33.33%",
                                    "col1_verticalAlign": "top",
                                    "col1_paddingBottom": "20px",
                                    "col1_paddingRight": "20px",
                                    "col2_width": "33.33%",
                                    "col2_verticalAlign": "top",
                                    "col2_paddingBottom": "20px",
                                    "col2_paddingRight": "20px",
                                    "col2_collapseIfEmpty": true,
                                    "col3_width": "33.33%",
                                    "col3_verticalAlign": "top",
                                    "col3_paddingBottom": "20px",
                                    "col3_paddingRight": "20px",
                                    "col3_collapseIfEmpty": true
                                },
                                "Visibility": {
                                    "Inventory": false
                                },
                                "Style": {
                                    "paddingTop": "40px",
                                    "paddingBottom": "40px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "width": "160px"
                                            },
                                            "Style": {
                                                "paddingBottom": "20px",
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "bios",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingBottom": "20px",
                        "paddingTop": "20px"
                    }
                }
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "150px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "image-default",
                                        "Type": "image",
                                        "Config": {
                                            "Block": {
                                                "width": "130px",
                                                "height": "130px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "name-default",
                                        "Type": "name",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontWeight": "",
                                                "fontStyle": "normal",
                                                "textTransform": "none",
                                                "fontSize": "14px",
                                                "lineHeight": "30px",
                                                "textLabelBirthdate": "b. ",
                                                "textLabelSeparator": " - ",
                                                "textLabelDeathdate": "d. ",
                                                "wrapDate": true,
                                                "colorDate": "",
                                                "styleDate": "header",
                                                "fontStyleDate": "normal",
                                                "fontWeightDate": ""
                                            },
                                            "Includes": {
                                                "Birthdate": true,
                                                "Deathdate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "bio-default",
                                        "Type": "bio",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "inventoryContainer-default",
                            "Type": "inventoryContainer",
                            "Config": {
                                "Block": {
                                    "columnCount": "3",
                                    "col1_width": "33.33%",
                                    "col1_verticalAlign": "top",
                                    "col1_paddingBottom": "20px",
                                    "col1_paddingRight": "20px",
                                    "col2_width": "33.33%",
                                    "col2_verticalAlign": "top",
                                    "col2_paddingBottom": "20px",
                                    "col2_paddingRight": "20px",
                                    "col2_collapseIfEmpty": true,
                                    "col3_width": "33.33%",
                                    "col3_verticalAlign": "top",
                                    "col3_paddingBottom": "20px",
                                    "col3_paddingRight": "20px",
                                    "col3_collapseIfEmpty": true
                                },
                                "Visibility": {
                                    "Inventory": true
                                },
                                "Style": {
                                    "paddingTop": "40px",
                                    "paddingBottom": "40px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "width": "160px"
                                            },
                                            "Style": {
                                                "paddingBottom": "20px",
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "header",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "textTransform": "none"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "12px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Classic",
        "IsDefault": false,
        "Type": "bios",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "0",
                    "paddingBottom": "0",
                    "paddingLeft": "8px",
                    "paddingRight": "8px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "maxWidth": "200px",
                        "maxHeight": "150px"
                    },
                    "Style": {
                        "paddingBottom": "40px",
                        "textAlign": "center"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "image-default",
                            "Type": "image",
                            "Config": {
                                "Block": {
                                    "maxHeight": "130px"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "name-default",
                            "Type": "name",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontWeight": "",
                                    "fontStyle": "normal",
                                    "textTransform": "none",
                                    "textLabelBirthdate": "b. ",
                                    "textLabelSeparator": " - ",
                                    "textLabelDeathdate": "d. ",
                                    "wrapDate": true
                                },
                                "Includes": {
                                    "Birthdate": false,
                                    "Deathdate": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "bio-default",
                            "Type": "bio",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    }
];

module.exports = Templates;